import type { TableColumnType, TableRowType } from '../../../../grid/reduxStore/table.types';
import { ColumnTypeIdentifier, RowTypesIdentifier } from '../../../../grid/reduxStore/table.types';
import type { EnhancedTableRowType } from '../../../../grid/reduxStore/table.types';

/**
 * The inverse of the PRICE-arrival rule: when the last PRICE column leaves the
 * table (deleted or retyped), line-item discounts lose their calculation basis
 * and must be cleared. Subtotal cell values are intentionally kept — they
 * become the starting point for manual entry.
 *
 * Rows are returned untouched (same references) when a PRICE column remains
 * or no BODY row carries a discount.
 */
export function clearRowDiscountsIfNoPriceColumn(rows: TableRowType[], updatedColumns: TableColumnType[]): TableRowType[] {
  const priceColumnRemains = updatedColumns.some((column) => column.columnType === ColumnTypeIdentifier.PRICE);
  if (priceColumnRemains) return rows;

  const hasDiscounts = rows.some((row) => row.rowType === RowTypesIdentifier.BODY && (row as EnhancedTableRowType).discount);
  if (!hasDiscounts) return rows;

  return rows.map((row) =>
    row.rowType === RowTypesIdentifier.BODY && (row as EnhancedTableRowType).discount ? { ...row, discount: null } : row
  );
}
